export default "__VITE_ASSET__DPalijpq__"